export default __webpack_public_path__ + "static/media/mobile6.fab85adc.png";